import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Programmesleft from './ProgrammesleftEle'
import { Container, Row, Col,Table } from 'react-bootstrap';



function MscEle() {
  return (
    <section className="project-detail">
      <Container>
        <Row>
          <Col md={4} className='c-left custom-padding-color mb-4'>
            <Programmesleft activeIndex={2} /> 
          </Col>

          <Col md={8} className='c-right'>
           
           
            <div className="c-heading">
              <h3>M.Sc.</h3>
              </div>
            <p>
              IIT Tirupati offers two years M.Sc. program(s) in the following Departments: 
            </p>


            <ul className='myulcustarrow'>
            <li>
              The Department of Mathematics and Statistics offers a post graduate program M.Sc. in Mathematics from the Academic year 2025-26.
              </li>
              <li>
                The Department of Mathematics and Statistics offers a post graduate program M.Sc. in Mathematics and Statistics from the Academic Year 2019-20.
              </li>
              <li>
                The Department of Chemistry and Department of Physics are offering post graduate programs M.Sc. in Chemistry and M.Sc. in Physics from the Academic Year 2020-21.
              </li>
              
            </ul>

            <Table bordered responsive className='mt-3'>
              <thead>
                <tr className='text-maroon'>
                  <th>Programme</th>
                  <th>Intake</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Chemistry</td>
                  <td>25</td>
                </tr>
                <tr>
                  <td>Mathematics</td>
                  <td>10</td>
                </tr>
                <tr>
                  <td>Mathematics and Statistics</td>
                  <td>20</td>
                </tr>
                <tr>
                  <td>Physics</td>
                  <td>20</td>
                </tr>
              </tbody>
            </Table>
            <p>Admission to all the M.Sc. program(s) are through JAM.</p>
    
              <p>For more information{' '}
              <b>
              <Link to="/m-sc-admission" target="_blank" rel="noopener noreferrer" className='c-link'>
                  click here
                </Link>
              </b></p>
          </Col>
        </Row>
      </Container>

    </section>
  );
}

export default MscEle;
